var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { DeleteIcon, FileUploadIcon, LoadingIcon } from '../icons';
import { Button } from './button';
export function FileUploader(_a) {
    var _b = _a.accept, accept = _b === void 0 ? '.docx,.doc,.pdf' : _b, _c = _a.maxSizeMB, maxSizeMB = _c === void 0 ? 15 : _c, onFileUpload = _a.onFileUpload, _d = _a.multiple, multiple = _d === void 0 ? false : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, file = _a.file, setFile = _a.setFile, files = _a.files, setFiles = _a.setFiles, fileError = _a.fileError, setFileError = _a.setFileError, _f = _a.className, className = _f === void 0 ? '' : _f;
    // File Validation Function
    var validateFile = useCallback(function (file) {
        if (file.size / 1024 / 1024 > maxSizeMB) {
            setFileError && setFileError(true);
            return false;
        }
        setFileError && setFileError(false);
        return true;
    }, [maxSizeMB, setFileError]);
    // Dropzone Configuration
    var onDrop = useCallback(function (acceptedFiles, fileRejections) {
        var validFiles = acceptedFiles.filter(validateFile);
        if (multiple) {
            setFiles && setFiles(function (prevFiles) { return __spreadArray(__spreadArray([], (prevFiles || []), true), validFiles, true); });
            onFileUpload && onFileUpload(validFiles);
        }
        else {
            var singleFile = validFiles[0] || null;
            setFile && setFile(singleFile);
            onFileUpload && onFileUpload(singleFile);
        }
    }, [validateFile, setFiles, setFile, onFileUpload, multiple]);
    var _g = useDropzone({
        onDrop: onDrop,
        accept: accept.split(',').reduce(function (acc, type) {
            acc[type] = [];
            return acc;
        }, {}),
        multiple: multiple,
    }), getRootProps = _g.getRootProps, getInputProps = _g.getInputProps;
    var handleRemoveFile = function (fileToRemove) {
        if (multiple) {
            setFiles &&
                setFiles(function (prevFiles) { return (prevFiles || []).filter(function (file) { return file !== fileToRemove; }); });
        }
        else {
            setFile && setFile(null);
        }
    };
    return (_jsxs("div", __assign({}, getRootProps(), { className: "\n        border-2 border-dashed rounded-lg \n        flex items-center gap-4 p-4 \n        cursor-pointer hover:border-vjwPrimary/80\n        transition-all duration-300\n        ".concat(fileError ? 'border-vjwDanger' : 'border-vjwPrimary', "\n        w-full\n        justify-center\n        flex-wrap\n        ").concat(className, "\n      "), children: [_jsx("input", __assign({}, getInputProps())), _jsxs("div", { className: 'flex gap-2 w-full items-center justify-center', children: [_jsx(FileUploadIcon, { hasFile: !!file }), _jsxs("div", { className: 'flex flex-col gap-2', children: [_jsx("div", { className: 'text-lg font-semibold text-gray-700', children: "Drag & Drop" }), _jsx("div", { className: 'text-sm text-gray-500', children: !file ? 'Your files here or Browse to upload' : 'File Ready to Upload' }), _jsxs("div", { className: 'text-xs text-gray-400', children: ["Only DOCX, PDF files with max size of ", maxSizeMB, " MB."] })] })] }), multiple && files && files.length > 0 && (_jsx("div", { className: 'flex w-full flex-wrap gap-2', children: files.map(function (file, index) { return (_jsxs("div", { className: 'flex items-center bg-vjwSecondary p-2 rounded-md justify-between gap-2', children: [_jsx("span", { className: 'text-sm text-gray-600 truncate max-w-[200px]', children: file.name }), _jsx("div", { className: 'flex items-center gap-2', children: isLoading ? (_jsx(LoadingIcon, {})) : (_jsx(Button, { variant: 'dangerSecondary', onClick: function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleRemoveFile(file);
                                }, className: 'rounded-full px-1 py-1', children: _jsx(DeleteIcon, {}) })) })] }, index)); }) })), !multiple && file && (_jsxs("div", { className: 'flex items-center bg-vjwSecondary p-2 rounded-md justify-between gap-2', children: [_jsx("span", { className: 'text-sm text-gray-600 truncate max-w-[200px]', children: file.name }), _jsx("div", { className: 'flex items-center gap-2', children: isLoading ? (_jsx(LoadingIcon, {})) : (_jsx(Button, { variant: 'dangerSecondary', onClick: function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveFile(file);
                            }, className: 'rounded-full px-1 py-1', children: _jsx(DeleteIcon, {}) })) })] }))] })));
}
